export default __webpack_public_path__ + "static/media/Client Logos – 02 – Sonder.d1e9692d.svg";